import { requests } from "api/HttpClient";

const { post, get, put, delete: deleteRequest } = requests;

const config = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

const maintenanceHistory = {
  getAll: ({ pageNumber = -1, pageSize = -1, maintenanceId }) => {
    let url = "/MaintenanceHistory/GetMaintenanceHistoryList";
    if (pageNumber && pageSize) {
      url += `?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    }
    if (maintenanceId) {
      url += `&maintenanceId=${maintenanceId}`;
    }

    return get(url);
  },
  getById: (id) => get(`/MaintenanceHistory/GetMaintenanceHistoryById/${id}`),
  create: (data) =>
    post("/MaintenanceHistory/AddMaintenanceHistory", data, config),
  addMaintenanceHistoryInMultipleMaintenances: (data) =>
    post(
      "/MaintenanceHistory/AddMaintenanceHistoryInMultipleMaintenances",
      data,
      config
    ),
  update: (id, data) =>
    put(`/MaintenanceHistory/UpdateMaintenanceHistory/${id}`, data, config),
  delete: (id) =>
    deleteRequest(`/MaintenanceHistory/DeleteMaintenanceHistory/${id}`),
};

export default maintenanceHistory;
